/**
 * HoldTimer - the illustrative "ON HOLD 41:07" chip on the Hold For Me card.
 *
 * Seconds tick up only while the chip is in the viewport (proof of patience,
 * not a claim about a real call — the label says Illustrative). Starts from a
 * scripted 41:07. Static under prefers-reduced-motion; aria-label stays fixed
 * so assistive tech isn't spammed by the tick.
 */

import { useEffect, useRef, useState } from 'react'
import { useInView } from 'framer-motion'
import { useReducedMotion } from './useReducedMotion'
import { isPrerender } from '../../utils/prerender'

const START_SECONDS = 41 * 60 + 7

function format(total: number): string {
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
  return `${m}:${String(s).padStart(2, '0')}`
}

export function HoldTimer() {
  const prefersReducedMotion = useReducedMotion()
  const ref = useRef<HTMLSpanElement>(null)
  const inView = useInView(ref, { margin: '-40px' })
  const [seconds, setSeconds] = useState(START_SECONDS)

  useEffect(() => {
    if (prefersReducedMotion || isPrerender() || !inView) return
    const id = setInterval(() => setSeconds((s) => s + 1), 1000)
    return () => clearInterval(id)
  }, [inView, prefersReducedMotion])

  return (
    <span ref={ref} className="rw-hold-timer">
      <span className="rw-hold-timer-label" aria-hidden="true">Sample</span>
      <span aria-hidden="true">ON HOLD {format(prefersReducedMotion || isPrerender() ? START_SECONDS : seconds)}</span>
      <span className="sr-only">{`Sample hold timer, ${format(START_SECONDS)} and counting`}</span>
    </span>
  )
}
